import AssetUploader from '../components/uploads/AssetUploader'
import SaveOnNavigate from '../components/SaveOnNavigate'
import N2StylesModal from '../components/N2StylesModal'

export default class ArticleJobsAssets {
  constructor(params) {
    this.params = params;
    this.assetUploader = new AssetUploader(this, {showNewImage: true});
  }

  unload() {
    this.assetUploader.unload()
  }

  index() {
    this.bindBulkDownload()
    this.bindFeatureAsset()
    this.assetUploader.init();
  }

  show() {
    this.bindFeatureAssetForm()
    new SaveOnNavigate();
  }

  assetUploadUrl() {
    return `/article_jobs/${this.params.articleJobId}/assets/`
  }

  assetUploadImageLabel() {
    return this.params.pluralLabel;
  }

  bindBulkDownload() {
    N2.handle("click", '.js-download-assets', (evt) => {
      let form = new N2Styles.manualForm($(evt.currentTarget).data('url'))
      const ids = $.map($('.is-checked'), (target) => {
        return $(target).data('id');
      });
      form.addInput('article_jobs[asset_ids]', ids)
      form.post()
    })
  }

  // When an asset is chosen to be featured on the ArticleJob Assets show view
  // and a different asset is already featured, we need to show a confirmation
  // modal to alert them that the featured asset is changing.
  bindFeatureAssetForm() {
    N2.handle("click", '.js-feature-asset', (evt) => {
      const form = $('form.edit_asset');
      if ($('.js-feature-asset-modal').length > 0 && $('#asset_feature:checked').length > 0) {
        evt.preventDefault();
        new N2StylesModal(".js-feature-asset-modal")
      }
    })

    N2.handle("click", '.js-feature-asset-confirm', (evt) => {
      N2.showProgressIndicator();
      $('form.edit_asset').submit();
    })
  }

  // When an asset is chosen to be featured on the ArticleJob Assets index view
  // this shows a modal confirmation that the featured asset is changing.
  bindFeatureAsset() {
    N2.handle("click", '.js-feature-asset', (evt) => {
      if ($('.js-feature-asset-modal').length > 0 ){
        if ($('.is-checked').next().children('.asset-feature').length > 0) {
          toastr.options["positionClass"] = "toast-bottom-center";
          toastr["info"]("This photo is already featured.");
          return false
        }
        new N2StylesModal(".js-feature-asset-modal")
      } else {
        this.submitFeatureForm($(evt.currentTarget).data('jobId'))
      }
    })

    N2.handle("click", '.js-feature-asset-confirm', (evt) => {
      this.submitFeatureForm($(evt.currentTarget).data('jobId'))
    })
  }

  submitFeatureForm(jobId) {
    let id = $('.is-checked').data('id');
    let form = new N2Styles.manualForm(`/article_jobs/${jobId}/assets/${id}`)

    form.addInput('asset[feature]', true)
    form.patch()
  }

  toggleNavBars() {
    if ($('.is-checked').length) {
      let multi = $('.is-checked').length > 1;

      let selectedLabel = multi ? this.params.pluralLabel : this.params.singularLabel;

      $('.js-feature-asset').toggleClass("hidden", multi);
      $('.js-article-asset-upload').addClass('hidden')
      $('.js-article-asset-actions').removeClass('hidden')
      $('.js-article-assets-selected').text(`${$('.is-checked').length} ${selectedLabel} Selected`)
    } else {
      $('.js-article-asset-actions').addClass('hidden')
      $('.js-article-asset-upload').removeClass('hidden')
    }
  }
}
